import { ActivityFeedsPropData } from "../../../types/DispatchExplorer"

export const StatusActivityFeed = ({
  data,
}: {
  data: ActivityFeedsPropData
}) => {
  return <span>{String(data.value)}</span>
}
